export const BOOLEAN_STRING = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
});

export const MAGIC_NUMBERS = Object.freeze({
  /**
   * Time in milliseconds
   */
  THROTTLE_INTERVAL: 300,
  /**
   * Time in milliseconds
   */
  DEBOUNCE_INTERVAL: 300,
});
